import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { CompanyDocument } from '@app/models/documents/company-document.model';
import { SigningTemplate } from '@app/models/documents/signing-template.model';

export type MergeFieldName = string;

export type MergeFieldsAPIResponse = {
    data: {
        attributes: {
            mergeFields: MergeFieldName[];
        };
    };
};

@Injectable({
    providedIn: 'root',
})
export class SigningTemplateService {
    constructor(private http: HttpClient) {}

    fetchMergeFields(companyDocument: CompanyDocument, signingTemplate: SigningTemplate): Promise<MergeFieldName[]> {
        const url = this.getMergeFieldsEndpoint(companyDocument, signingTemplate);

        return this.http
            .get(url)
            .toPromise()
            .then((res: MergeFieldsAPIResponse) => {
                return res.data.attributes.mergeFields;
            });
    }

    private getMergeFieldsEndpoint(companyDocument: CompanyDocument, signingTemplate: SigningTemplate): string {
        return (
            environment.api +
            `/v2/companyDocuments/${companyDocument.id}/signingTemplates/${signingTemplate.id}/mergeFields`
        );
    }
}
